import { useEffect, useRef } from 'react';

//* Context
import { withUIContext } from '@/context';

//* Styles
import BurgerMenuIconStyle from './style';

const BurgerMenuIcon = ({ winWidth, isBurgerMenuOpen }) => {
	const wrapperInnerRef = useRef();

	function menuBtnFunction() {
		if (wrapperInnerRef.current) {
			wrapperInnerRef.current.classList.toggle('active');
		}
	}

	useEffect(() => {
		if (!isBurgerMenuOpen && wrapperInnerRef.current) {
			wrapperInnerRef.current.classList.remove('active');
		}
	}, [winWidth, isBurgerMenuOpen]);

	return (
		<BurgerMenuIconStyle>
			<div className='all-btn'>
				<div
					ref={wrapperInnerRef}
					className='menu-btn-1'
					onClick={() => {
						menuBtnFunction();
					}}>
					<span></span>
				</div>
			</div>
		</BurgerMenuIconStyle>
	);
};

export default withUIContext(BurgerMenuIcon, ['winWidth', 'isBurgerMenuOpen']);
